import React, { useState } from 'react';
import { Form, Input, Button, Segmented } from 'antd';
import './styles.css';
import SelectChecker from '../../../../../../../../utils/shared/components/Select/SelectChecker/SelectChecker';

export const showHideOptions = [
    { label: 'Показать', value: '1' },
    { label: 'Скрыть', value: '2' },
];

interface LayoutControlsProps {
    isEdit: boolean;
    formLeft: any;
    selectedLayout: any;
    handleLayoutSave: any;
    setDeleteLayoutModal: any;
    setIsEdit: any;
    setIsShowNameDevice: any;
}

const LayoutControls: React.FC<LayoutControlsProps> = ({
    isEdit,
    formLeft,
    selectedLayout,
    handleLayoutSave,
    setDeleteLayoutModal,
    setIsEdit,
    setIsShowNameDevice,
}) => {
    const [showHide] = useState<'1' | '2'>('1');

    return (
        <>
            {isEdit && (
                <div
                    className="description_layout"
                    style={{
                        display: 'flex',
                        gap: '16px',
                        width: '100%',
                        marginTop: 24,
                    }}
                >
                    <Form
                        form={formLeft}
                        className="form"
                        name="description-layout-form"
                        wrapperCol={{ span: 24 }}
                        style={{
                            display: 'flex',
                            gap: '16px',
                            width: '100%',
                            flexDirection: 'row',
                        }}
                        initialValues={{
                            name: selectedLayout?.name || '',
                            description: selectedLayout?.description || '',
                        }}
                    >
                        <Form.Item
                            label={<span className="inputLabel title medium">Название</span>}
                            name="name"
                            style={{
                                flex: 1,
                                margin: 0,
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Пожалуйста, введите Название',
                                },
                            ]}
                        >
                            <Input className="input" />
                        </Form.Item>
                        <Form.Item
                            label={<span className="inputLabel title medium">Описание</span>}
                            name="description"
                            style={{
                                flex: 1,
                                margin: 0,
                            }}
                            rules={[
                                {
                                    required: false,
                                    message: 'Пожалуйста, введите описание',
                                },
                            ]}
                        >
                            <Input className="input" />
                        </Form.Item>
                        <Form.Item
                            label={
                                <span
                                    className="inputLabel nameDevice title medium"
                                    style={{
                                        flex: 1,
                                        margin: 0,
                                    }}
                                >
                                    Названия устройств
                                </span>
                            }
                            initialValue={showHide}
                            name="nameOfDevice"
                            rules={[
                                {
                                    required: false,
                                    message: 'Пожалуйста, введите Название',
                                },
                            ]}
                        >
                            <Segmented
                                options={showHideOptions}
                                value={showHide}
                                onChange={(value) =>
                                    setIsShowNameDevice(value === '1')
                                }
                                className="device-names-segmented"
                            />
                        </Form.Item>
                    </Form>
                </div>
            )}
            <div className="DescButtons_layout">
                {isEdit ? (
                    <>
                        <Button
                            className={'button-base button-size-medium button-type-primary'}
                            onClick={() => handleLayoutSave()}
                        >
                            Сохранить
                        </Button>
                        <Button
                            className={
                                'button-base button-size-medium button-type-primary button-state-danger'
                            }
                            onClick={() => setDeleteLayoutModal(true)}
                        >
                            Удалить
                        </Button>
                    </>
                ) : (
                    <>
                        <Button
                            className={'button-base button-size-medium button-type-primary'}
                            onClick={() => setIsEdit(true)}
                        >
                            Редактировать
                        </Button>
                    </>
                )}
            </div>
        </>
    );
};

export default LayoutControls;
